module.exports = __webpack_public_path__ + "static/media/oceansgrn.10c857b7.png";